module.exports = __webpack_public_path__ + "static/media/recharge.8017337b.svg";